import React, {useEffect} from 'react';
import {PageWrapper} from '../../components/Layout/Page';
import {PageHeader} from '../../components/Common/PageHeader';
import {useChangeSendCodeState, useCurrentGroupFromUrlParam, useGetCurrentGroup} from '../../hooks/state';
import {PageLoader} from '../../components/Common/PageLoader';
import {EmptyGroupState} from '../../components/Common/EmptyState/EmptyGroupState';
import {getGuestLink} from '../../constants/routes';
import {StarLine} from '../../components/Common/StarLine';
import {GroupInfoExpander} from '../../components/Common/GroupInfoExpander';
import {SendCodeForm} from './form';
import {SendCodesSubmit} from './submit';

export const SendCodePage = () => {
  useCurrentGroupFromUrlParam(); //store current group from url param if not stored
  const {currentGroup} = useGetCurrentGroup();
  const {clear} = useChangeSendCodeState();

  const group = currentGroup.group;

  useEffect(() => clear(), []); //clear state
  if (!group && currentGroup?.loading) return <PageLoader />;
  if (!group) return <EmptyGroupState />;

  return (
    <PageWrapper>
      <PageHeader
        title="Send Code"
        subtitle="Add contact details for your guest."
        linkText="Guest List"
        link={getGuestLink(group)}
      />
      <SendCodeForm group={group} /> {/* FORM */}
      <StarLine /> {/* DIVIDER */}
      <GroupInfoExpander group={group} /> {/* GROUP INFO */}
      <SendCodesSubmit /> {/* SUBMIT BUTTON */}
    </PageWrapper>
  );
};
